import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import { PRESCHOOL } from 'constants/schoolTypes';
import { getFileUrl } from 'actions/files';
import { clearDocumentsFromStore, clearSectionDocumentsFromStore, getDocumentsBySectionId, getDocumentsPage } from 'actions/documents';
import { clearPostsFromStore, getPostsBySectionId, getPostsPage, setPostCollectionInfo } from 'actions/posts';
import { fetch_preschoolgoals } from 'actions/preschoolform';
import { getMentorGroups } from 'actions/sections';
import { setPageTitle, setPageActions } from 'actions/header';
import { getDescription } from 'helpers/content';
import User from '_class/User';
import LoadingCards from 'components/Cards/LoadingCard';
import Date from 'components/Presentation/Date/Date';
import SectionTitle from 'components/Presentation/SectionTitle';
import Documentation from 'containers/Forms/Documentation';
import Post from 'containers/Forms/Post';
import Modal from 'containers/Modals/Modal';
import Block, { BlockWrapper } from 'UI/Elements/Block';
import { Icon, TooltipMenu, Button, Radio } from '@haldor/ui';
import FromNow from 'components/Presentation/Date/FromNow';

var MyPosts = /*#__PURE__*/function (_Component) {
  _inherits(MyPosts, _Component);

  var _super = _createSuper(MyPosts);

  function MyPosts(props) {
    var _this;

    _classCallCheck(this, MyPosts);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var user, isPreschool;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              user = new User(_this.props.currentUser);
              isPreschool = user.getActiveSchool().type == PRESCHOOL;

              _this.props.clearDocumentsFromStore();

              _this.props.clearPostsFromStore();

              _this.fetchData(_this.state.page);

              if (_this.props.preschoolGoals.length < 1 && isPreschool) {
                _this.props.fetch_preschoolgoals();
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchData", function (page) {
      var loadState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return new Promise(function (resolve) {
        var user = new User(_this.props.currentUser);
        var isPreschool = user.getActiveSchool().type == PRESCHOOL; // Offset start and end date by 1 day bc <>

        var start = _this.props.userRole === "student" ? null : moment(_this.state.startDate).subtract('1', 'days').format('YYYY-MM-DD');
        var end = moment(_this.state.endDate).add('1', 'days').format('YYYY-MM-DD');
        var promises = [];

        if (loadState) {
          _this.setState({
            loadingPosts: true
          });
        }

        var getPostsPage = _this.props.getPostsPage(page, 'published', start, end);

        promises.push(getPostsPage);

        if (isPreschool) {
          if (loadState) {
            _this.setState({
              loadingDocuments: true
            });
          }

          var _getDocumentsPage = _this.props.getDocumentsPage(page, 'DOCUMENTATION_PUBLISHED', start, end);

          promises.push(_getDocumentsPage);
        }

        Promise.all(promises).then(function () {
          _this.setState({
            loadingDocuments: false,
            loadingPosts: false
          });

          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDocumentModal", function () {
      _this.setState({
        documentModal: !_this.state.documentModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEventModal", function () {
      _this.setState({
        eventModal: !_this.state.eventModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSendAllModal", function () {
      _this.setState({
        sendAllModal: !_this.state.sendAllModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var combined = _this.props.combined;
      var i = 0;
      var renderedItems = 0;

      if (combined.length > 0) {
        var returnDOM = /*#__PURE__*/React.createElement(BlockWrapper, {
          cols: 3
        }, combined ? combined.map(function (document) {
          if (i < _this.props.limit) {
            var result = _this.renderDocument(document);

            if (result != null) {
              i++;
              renderedItems++;
            }

            return result;
          } else {
            return null;
          }
        }) : null);

        if (renderedItems > 0) {
          return returnDOM;
        }
      }

      return /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: 'center'
        }
      }, _this.props.translate('no-items-found'));
    });

    _defineProperty(_assertThisInitialized(_this), "headerContent", function (document) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'left'
        }
      }, document.author != null ? typeof document.author == 'string' ? document.author : "".concat(document.author.firstName != null ? document.author.firstName : '', " ").concat(document.author.lastName != null ? document.author.lastName : '') : ' '), /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, document.published != null ? moment.utc(document.published).isAfter(moment()) ? /*#__PURE__*/React.createElement(FromNow, null, moment.utc(document.published).local().format()) : /*#__PURE__*/React.createElement(Date, null, moment.utc(document.published).local()) : null), document.important && document.eventDate != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'left'
        }
      }) : null, document.status == 'POST_DRAFT' || document.status == 'DOCUMENTATION_DRAFT' ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right',
          marginRight: 8
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'red',
          fontSize: '0.9em'
        }
      }, _this.props.translate('Draft'))) : null, document.important && document.eventDate != null && moment() <= moment(document.eventDate) ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'red',
          fontSize: '0.9em',
          marginRight: '8px'
        }
      }, _this.props.translate('important!'))) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "content", function (document) {
      if (document.ReferenceType == 'post') {
        var strippedDescription = getDescription(document.body).replace(/(<([^>]+)>)/ig, '');

        if (strippedDescription.length > 99) {
          strippedDescription = strippedDescription.slice(0, 100) + '…';
        }

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, document.title), /*#__PURE__*/React.createElement("p", {
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          },
          dangerouslySetInnerHTML: {
            __html: strippedDescription
          }
        }));
      } else {
        if (document.description) {
          var _strippedDescription = getDescription(document.description).replace(/(<([^>]+)>)/ig, '');

          if (_strippedDescription.length > 99) {
            _strippedDescription = _strippedDescription.slice(0, 100) + '…';
          }

          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, document.title), /*#__PURE__*/React.createElement("p", {
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            },
            dangerouslySetInnerHTML: {
              __html: _strippedDescription
            }
          }));
        }

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, document.title));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "footerContent", function (document) {
      var preschoolGoals = _this.props.preschoolGoals;

      if (document.associatedGoals && document.associatedGoals.length > 0) {
        var groups = [];

        if (preschoolGoals && preschoolGoals.length > 0) {
          preschoolGoals.map(function (goal) {
            var inDocument = document.associatedGoals.find(function (goalOb) {
              return goalOb.goalId == goal.id;
            });

            if (typeof inDocument != 'undefined') {
              var inArray = groups.findIndex(function (i) {
                return i.name == goal.group;
              });

              if (inArray > -1) {
                return groups[inArray].count++;
              } else {
                var group = {
                  'name': goal.group,
                  'color': goal.colorCode,
                  'count': 1
                };
                return groups.push(group);
              }
            }
          });
        }

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, _this.props.translate('goals')), groups.length > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "goal-preview-container"
        }, groups.map(function (group) {
          return /*#__PURE__*/React.createElement("div", {
            key: "goal-" + group.name,
            className: "goal-preview",
            style: {
              backgroundColor: group.color
            }
          }, group.name, " (", group.count, ")");
        })) : null);
      } else {
        return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderDocument", function (document) {
      var link = '';
      var limit = _this.props.limit;

      if (document.ReferenceType == 'post') {
        link = 'post/' + document.id;
      } else {
        link = 'preschooldocument/' + document.id;
      } // Do not show important posts if this is for dashboard.
      // Assuming it is for dashboard if there is a limit (also since that is what decides if Importat is to be shown)


      if (limit && document.important && document.ReferenceType == "post" && moment().isSameOrAfter(moment(document.published), 'day') && moment(document.eventDate).isSameOrAfter(moment(), 'day') && moment().isSameOrAfter(moment(document.eventDate).subtract(7, "days"), 'day')) {
        return null;
      }

      var expireDate = moment(document.validUntil).hour(23).minute(59);

      if (_this.props.limit != false && document.validUntil != null && expireDate.diff(moment()) < 0) {
        return null;
      }

      var file = null;

      if (document.associatedFiles != null && document.associatedFiles.length > 0) {
        file = document.associatedFiles.find(function (file) {
          return file.type && file.type.indexOf('image') > -1;
        });
      }

      return /*#__PURE__*/React.createElement(Block, {
        key: document.id,
        headerContent: _this.headerContent(document),
        image: file,
        content: _this.content(document),
        footerContent: _this.footerContent(document),
        link: link
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCreateButton", function () {
      var isPreschool = false;

      if (_this.props.currentUser.schools.getActiveSchool(_this.props.currentUser.userId).type == PRESCHOOL) {
        isPreschool = true;
      }

      var user = new User(_this.props.currentUser);

      if (!user.isStudent() && isPreschool) {
        return /*#__PURE__*/React.createElement("div", {
          className: "create-container",
          style: {
            display: 'inline-block'
          }
        }, /*#__PURE__*/React.createElement(TooltipMenu, {
          trigger: /*#__PURE__*/React.createElement(Button, {
            type: "secondary"
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Plus"
          }), " ", _this.props.translate('Create'))
        }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: _this.toggleDocumentModal
        }, _this.props.translate('Create documentation')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: _this.toggleEventModal
        }, _this.props.translate('Create post')), user.isOperationManager() ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: _this.toggleSendAllModal
        }, _this.props.translate('Create schoolwide announcement')) : null));
      } else {
        if (!user.isStudent()) {
          if (user.isOperationManager()) {
            return /*#__PURE__*/React.createElement("div", {
              className: "create-container",
              style: {
                display: 'inline-block'
              }
            }, /*#__PURE__*/React.createElement(TooltipMenu, {
              trigger: /*#__PURE__*/React.createElement(Button, {
                type: "secondary"
              }, /*#__PURE__*/React.createElement(Icon, {
                name: "Plus"
              }), " ", _this.props.translate('Create'))
            }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
              onClick: _this.toggleEventModal
            }, _this.props.translate('Create post')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
              onClick: _this.toggleSendAllModal
            }, _this.props.translate('Create schoolwide announcement'))));
          }

          return /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: _this.toggleEventModal
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Plus"
          }), " ", _this.props.translate('Create'));
        }

        return null;
      }
    });

    _this.state = {
      documentModal: false,
      eventModal: false,
      sendAllmodal: false,
      loadingDocuments: false,
      loadingPosts: false,
      page: 1,
      startDate: moment().subtract('3', 'months').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    };
    return _this;
  }

  _createClass(MyPosts, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loadingDocuments = _this$state.loadingDocuments,
          loadingPosts = _this$state.loadingPosts;
      var isPreschool = false;
      var user = new User(this.props.currentUser);

      if (user.getActiveSchool().type == PRESCHOOL) {
        isPreschool = true;
      }

      var sections = [];

      if (user.isMentor() || user.isAdministrator() || user.isSchoolLeader() || user.isOperationManager()) {
        sections = this.props.groups.concat(this.props.mentorGroups);
      } else {
        sections = this.props.groups;
      }

      if (!(user.isStudent() || user.isSchoolLeader() || user.isAdministrator() || user.isOperationManager())) {
        sections = sections.filter(function (section) {
          return section.userRole === "OWNER";
        });
      }

      var importantPosts = [];
      this.props.combined.forEach(function (post) {
        var SevenDaysAgo = moment(post.eventDate).subtract(7, "days");

        if (post.important && post.ReferenceType == "post" && moment().isSameOrAfter(moment(post.published), 'day') && moment(post.eventDate).isSameOrAfter(moment(), 'day') && moment().isSameOrAfter(SevenDaysAgo, 'day')) {
          importantPosts.push(post);
        }
      });
      importantPosts.sort(function (a, b) {
        return moment(a.eventDate).unix() - moment(b.eventDate).unix();
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "preschooldocuments"
      }, this.props.combined.find(function (post) {
        return post.important && post.ReferenceType == "post" && moment().isSameOrAfter(moment(post.published), 'day') && moment(post.eventDate).isSameOrAfter(moment(), 'day') && moment().isSameOrAfter(moment(post.eventDate).subtract(7, "days"), 'day');
      }) != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          borderBottom: '1px solid #DFE1E2',
          marginBottom: '3.2em',
          paddingBottom: '1.9em'
        }
      }, /*#__PURE__*/React.createElement(SectionTitle, null, this.props.overview ? /*#__PURE__*/React.createElement(Icon, {
        name: "Post"
      }) : null, /*#__PURE__*/React.createElement("span", null, this.props.translate('important-posts'))), importantPosts.map(function (post) {
        return /*#__PURE__*/React.createElement(Link, {
          to: '/post/' + post.id,
          style: {
            textDecoration: 'none',
            color: 'inherit'
          },
          key: post.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "block-container",
          style: {
            display: 'inline-block',
            margin: '5px'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "block-content",
          style: {
            padding: '0.8rem'
          }
        }, /*#__PURE__*/React.createElement("h3", null, post.title))));
      })) : null, !user.isStudent() && isPreschool ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.documentModal,
        onClose: this.toggleDocumentModal,
        title: this.props.translate('create-new-documentation')
      }, /*#__PURE__*/React.createElement(Documentation, {
        onModalClose: this.toggleDocumentModal
      })) : null, !user.isStudent() ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.eventModal,
        onClose: this.toggleEventModal,
        title: this.props.translate('create-new-post')
      }, /*#__PURE__*/React.createElement(Post, {
        onModalClose: this.toggleEventModal
      })) : null, !user.isStudent() ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.sendAllModal,
        onClose: this.toggleSendAllModal,
        title: this.props.translate('Create schoolwide announcement')
      }, /*#__PURE__*/React.createElement(Post, {
        selectMultipleSchools: true,
        onModalClose: this.toggleEventModal
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(Icon, {
        name: "Post"
      }), /*#__PURE__*/React.createElement("span", null, this.props.translate('preschooldocument-posts')), this.renderCreateButton(), /*#__PURE__*/React.createElement(Link, {
        to: "posts",
        className: "see-more"
      }, this.props.translate('show-all'))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "posts-section-container"
      }, loadingDocuments || loadingPosts ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 3
      }) : this.renderContent(), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      })));
    }
  }]);

  return MyPosts;
}(Component);

_defineProperty(MyPosts, "defaultProps", {
  limit: 3
});

function mapStateToProps(state) {
  return {
    user: state.user.user,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations),
    documentations: state.CombinedEvents.documentations,
    posts: state.CombinedEvents.posts,
    collectionInformation: state.Posts.collectionInformation,
    preschoolGoals: state.PreschoolGoals.preschoolGoals,
    groups: state.sections.educationGroups,
    combined: state.CombinedEvents.combined,
    groupCombined: state.CombinedEvents.sectionCombined,
    mentorGroups: state.sections.mentorGroups
  };
}

export default connect(mapStateToProps, {
  getDocumentsPage: getDocumentsPage,
  getPostsPage: getPostsPage,
  getFileUrl: getFileUrl,
  fetch_preschoolgoals: fetch_preschoolgoals,
  getPostsBySectionId: getPostsBySectionId,
  getDocumentsBySectionId: getDocumentsBySectionId,
  clearSectionDocumentsFromStore: clearSectionDocumentsFromStore,
  clearDocumentsFromStore: clearDocumentsFromStore,
  clearPostsFromStore: clearPostsFromStore,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  getMentorGroups: getMentorGroups,
  setPostCollectionInfo: setPostCollectionInfo
})(MyPosts);